import { ErrorApiResponse, ISignatureRequestResponse } from './index'

export const isErrorApiResponse = (data: any | ErrorApiResponse): data is ErrorApiResponse =>
  typeof (data as ErrorApiResponse).message !== 'undefined'
export const isSignatureRequestResponse = (
  data: any | ISignatureRequestResponse,
): data is ISignatureRequestResponse =>
  typeof (data as ISignatureRequestResponse).signUrl !== 'undefined'
  || typeof (data as ISignatureRequestResponse).listing !== 'undefined'
